import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Product, TranslationService } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { filter, map, Observable, withLatestFrom } from 'rxjs';
import {
  ColumnDefinitionV3,
  ColumnRendererComponentV3,
  TableV3Component,
} from '@gea/digital-ui-lib';
import { DataSheet } from 'src/app/custom/models/classes/datasheet.model';
import { CustomAttachmentDownloadRendererComponent } from './attachment-download-column.component';
import { ProductDataSheetService } from '../../../services/product/product-datasheet.service';
import { CustomAttachmentCategoryRendererComponent } from './attachment-category-column.component';

@Component({
  selector: 'custom-product-attachment-tab',
  templateUrl: './product-attachment-tab.component.html',
  styleUrl: './product-attachment-tab.component.scss',
  imports: [CommonModule, TableV3Component],
})
export class ProductAttachmentTabComponent implements OnInit {
  protected currentProductService = inject(CurrentProductService);

  translationService = inject(TranslationService);

  productDataSheetService = inject(ProductDataSheetService);

  product$: Observable<Product | null> | undefined;

  dataSheets$: Observable<DataSheet[]> | undefined;

  documentsTableColumns$: Observable<ColumnDefinitionV3[]> = this.translationService
    .translate('TabPanelContainer.attachmentTable.filename')
    .pipe(
      withLatestFrom(
        this.translationService.translate('TabPanelContainer.attachmentTable.language'),
        this.translationService.translate('TabPanelContainer.attachmentTable.category'),
        this.translationService.translate('TabPanelContainer.attachmentTable.mime'),
      ),
      map(([filenameTrans, languageTrans, categoryTrans, mimeTrans]) => [
        // {
        //   displayName: '',
        //   key: 'select',
        //   renderer: {
        //     component: CheckboxRendererComponent as ColumnRendererComponentV3<DataSheet>,
        //   },
        //   // headerRenderer: {
        //   //   component: CheckboxHeaderRendererComponent as HeaderRendererComponentV3<DataSheet>,
        //   // },
        // },
        {
          displayName: filenameTrans,
          key: 'fileName',
        },
        {
          displayName: languageTrans,
          key: 'language',
        },
        {
          displayName: categoryTrans,
          key: 'category',
          renderer: {
            component:
              CustomAttachmentCategoryRendererComponent as ColumnRendererComponentV3<unknown>,
            // config: {
            //   prefix: 'ASSET-DETAIL.DOCUMENT-DOWNLOAD.TABLE.DOCUMENT-TYPE.',
            // },
          },
        },
        {
          displayName: mimeTrans,
          key: 'mime',
        },
        {
          displayName: '',
          key: 'url',
          renderer: {
            component:
              CustomAttachmentDownloadRendererComponent as ColumnRendererComponentV3<unknown>,
            // config: {
            //   prefix: 'ASSET-DETAIL.DOCUMENT-DOWNLOAD.TABLE.DOCUMENT-TYPE.',
            // },
          },
        },
        // {
        //   displayName: 'ASSET-DETAIL.DOCUMENT-DOWNLOAD.TABLE.DOCUMENT-LANGUAGE',
        //   key: 'selectedLanguage',
        //   renderer: {
        //     component: DocumentLanguageRendererComponent as ColumnRendererComponentV3<SelectOption[]>,
        //   },
        //   width: 20,
        // },
      ]),
    );

  currentlySelectedPublicDocuments: DataSheet[] = [];

  ngOnInit() {
    this.dataSheets$ = this.currentProductService
      .getProduct()
      // eslint-disable-next-line no-unsafe-optional-chaining
      .pipe(
        filter((product) => product !== undefined && product !== null),
        map((product) => product.dataSheets),
      );
  }

  rowClicked($event: DataSheet) {
    window.open(this.productDataSheetService.getUrl($event), '_blank');
  }
}
